import icono1 from "../Recursos/web_icon.png";
import icono2 from "../Recursos/tienda_icon.png";
import icono3 from "../Recursos/soft_icon.png";

export const servicios = [
  {
    "id": "1",
    "titulo": "Diseño de páginas web",
    "descripcion": "Profesionales en diseño enfocados en fortalecer tu marca ",
    "contenido": [
      {
        "subtitulo": "¿Qué es una página web?",
        "parrafos": [
          "El diseño web no es solo cuestión de estética, es la primera impresión que tu negocio transmite a los visitantes. ¿Sabías que un usuario tarda menos de un segundo en decidir si un sitio le parece profesional y confiable? Un buen diseño es tan importante como un buen funcionamiento: ambos son clave para ganar la confianza de tus clientes."
        ]
      },
      {
        "subtitulo": "¿Qué hace que un diseño sea realmente bueno?",
        "parrafos": [
          "Para que tu página destaque debe cumplir con:",
          "⚡ Velocidad de carga rápida para no perder visitantes.",
          "\uD83C\uDFAF Botones y llamados a la acción en el lugar correcto.",
          "\uD83D\uDDC2\uFE0F Organización clara y navegación intuitiva.",
          "\uD83D\uDD27 Tecnología actualizada que garantiza mayor vida útil.",
          "\uD83D\uDDA5\uFE0F Experiencia optimizada en cualquier dispositivo."
        ]
      },
      {
        "subtitulo": "Responsive Web Design",
        "parrafos": [
          "Hoy en día, si tu página no se adapta a móviles, prácticamente no existe.\u2028 Desde el 2015, Google exige que los sitios web sean responsive para posicionarse en los resultados de búsqueda.\u2028 Con nosotros tendrás un sitio web que se verá y funcionará de manera impecable en computadores, tablets y smartphones."
        ]
      },
      {
        "subtitulo": "¿Por qué destaca tu marca con una página web?",
        "parrafos": [
          " Un logo memorable, fotografías profesionales y videos bien producidos transmiten confianza y generan recordación en tus clientes. Nuestro equipo creativo puede ayudarte a elevar la imagen de tu negocio y a comunicar lo que realmente quieres transmitir."
        ]
      }
    ],
    "imagen": "https://tusitio.com/images/react-mui.jpg",
    "alt": "Ejemplo de diseño con React y Material UI",
    "icono": icono1,
    "autor": "Diego Polo",
    "fechaPublicacion": "Martes, Julio 8, 2025",
    "keywords": [
      "React",
      "Material UI",
      "Diseño Web",
      "Frontend",
      "UI/UX"
    ],
    "categoria": "Desarrollo Web",
    "url": "/blog/como-disenar-con-react-y-mui"
  },



  {
    "id": "2",
    "titulo": "Tienda online",
    "descripcion": "Una tienda online te permite vender tus productos o servicios en internet 24/7, llegar a más clientes, aumentar tus ventas y fortalecer tu marca.",
    "contenido": [
      {
        "subtitulo": "¿Para que sirve una Tienda online?",
        "parrafos": [
          "Una tienda online es el canal digital que te permite vender tus productos o servicios en internet, disponible las 24 horas del día, los 7 días de la semana. Funciona como un catálogo y ayuda a llegar a más clientes, aumentar tus ventas y mejorar tu marca"
        ]
      },
      {
        "subtitulo": "¿Puedo vender mis productos en línea?",
        "parrafos": [
          "Sí. Tu tienda online te permitirá mostrar todo tu catálogo de productos, organizarlos en categorías, gestionar inventario y ofrecer diferentes métodos de pago seguros. Es como trasladar tu negocio físico al mundo digital, con la ventaja de que cualquier persona puede comprar desde cualquier lugar."
        ]
      },
      {
        "subtitulo": "¿Qué incluye una tienda online?",
        "parrafos": [
          "Catálogo de productos organizado por categorías, con fotos, descripciones y precios.",
          "Pasarela de pagos segura (tarjeta, PSE, contraentrega o transferencias).",
          "Carrito de compras y pedidos automáticos, con notificaciones en tiempo real.",
          "Panel de administración fácil de usar, para actualizar productos, precios e inventario.",
          "Optimización SEO, para que tu tienda aparezca en Google.",
          "Integración con WhatsApp y redes sociales, para atender clientes rápidamente."
        ]
      },
      {
        "subtitulo": "¿Puedo recibir pedidos por mi tienda online?",
        "parrafos": [
          "Tu tienda contará con carrito de compras y pasarelas de pago. Cada pedido se confirmará de inmediato y podrás recibir notificaciones por correo o WhatsApp para no perder ninguna venta."

        ]
      },
      {
        "subtitulo": "¿Cómo implementar diseño de experiencia en tu negocio?",
        "parrafos": [
          "Investiga a tu audiencia: entiende qué necesitan tus clientes.",
          "Diseña pensando en la usabilidad: prioriza lo simple y accesible.",
          "Integra el diseño con la estrategia: alinea UX/UI con los objetivos de negocio.",
          "Prueba y mejora constantemente: mide cómo interactúan los usuarios y optimiza."
        ]
      },
      {
        "subtitulo": "¿Pueden encontrar mi negocio en Google?",
        "parrafos": [
          "Sí. Al crear tu tienda optimizamos tu página para que aparezca en los resultados de búsqueda de Google. Además, podemos vincular tu negocio a Google Maps y Google My Business, lo que aumenta tu visibilidad local y genera mayor confianza entre tus clientes."
        ]
      },
      {
        "subtitulo": "Conclusión",
        "parrafos": [
          "Una tienda online no es solo un canal de ventas, sino una herramienta estratégica para escalar tu negocio, ampliar tu alcance y conectar con clientes las 24/7. Al integrar catálogo, pagos seguros, gestión de pedidos y optimización en buscadores, tu marca gana visibilidad, confianza y competitividad en el mercado digital."
        ]
      }
    ],
    "imagen": "https://tusitio.com/images/seo-react.jpg",
    "alt": "Optimización SEO en React",
    "icono": icono2,
    "autor": "Diego Polo",
    "fechaPublicacion": "Miercoles, Junio 18, 2025",
    "keywords": [
      "SEO",
      "React",
      "Indexación",
      "Google",
      "Marketing Digital"
    ],
    "categoria": "Marketing Digital",
    "url": "/blog/optimizacion-seo-en-react"
  },
  {
    "id": "3",
    "titulo": "Desarrollo de software",
    "descripcion": "Un software que para organizar información ",
    "contenido": [
      {
        "subtitulo": "¿Necesito un software para mi negocio?",
        "parrafos": [
          "Si aún manejas tus procesos con hojas de Excel, cuentas en papel o sistemas que no se conectan entre sí, tu negocio está perdiendo tiempo, dinero y oportunidades.\nHoy en día, la digitalización es clave para optimizar procesos, reducir errores y tomar mejores decisiones en menos tiempo. Un software bien desarrollado te permitirá tener el control total de tu empresa desde un solo lugar."
        ]
      },
      {
        "subtitulo": "¿Qué puede hacer un software por tu empresa?",
        "parrafos": [
          "Llevar tus cuentas y balances en tiempo real.\nGestionar pedidos y despachos de forma inmediata.\nRegistrar clientes y mantener una base de datos organizada.\nProteger tu información y evitar pérdidas por imprevistos.\nAutomatizar procesos repetitivos y ahorrar horas de trabajo."
        ]
      },
      {
        "subtitulo": "Ejemplos comunes de uso",
        "parrafos": [
          "Sistemas de facturación o gestión de inventarios.",
          "Plataformas internas para coordinar equipos de trabajo.",
          "Aplicaciones móviles para clientes o empleados.",
          "Herramientas de análisis de datos para la toma de decisiones."
        ]
      },
      {
        "subtitulo": "El proceso de creación",
        "parrafos": [
          "Normalmente, el desarrollo de software incluye varias etapas: análisis de necesidades, diseño de la solución, programación, pruebas y mantenimiento. Cada una de estas fases busca asegurar que la herramienta sea confiable y fácil de usar."

        ]
      }
    ],
    "imagen": "https://tusitio.com/images/seo-react.jpg",
    "alt": "Optimización SEO en React",
    "icono": icono3,
    "autor": "Diego Polo",
    "fechaPublicacion": "Miercoles, Junio 18, 2025",
    "keywords": [
      "SEO",
      "React",
      "Indexación",
      "Google",
      "Marketing Digital"
    ],
    "categoria": "Marketing Digital",
    "url": "/blog/optimizacion-seo-en-react"
  }
]
